import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

import { firebaseConfig } from '../config';
import { getImpersonationSession } from '../../helpers/impersonation';

export const getFirebaseApp = () => {
    const session = getImpersonationSession();
    const name = session ? `impersonation-${session}` : '[DEFAULT]';
    return (
        firebase.apps.find((app) => app.name === name) ||
        firebase.initializeApp(firebaseConfig, name)
    );
};

const firebaseApi = async () => {
    getFirebaseApp();

    return firebase;
};

export default firebaseApi;
